/* MKA SPORT storefront behaviour. Progressive enhancement: every feature has a no-JS fallback. */
(() => {
  const R = window.mkaRoutes || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', search: '/search', predictive: '/search/suggest' };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  function money(cents) {
    const fmt = window.mkaMoney || '€{{amount}}';
    const n = (Number(cents) || 0) / 100;
    const fix = (d, th, dec) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2, ',', '.'), amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','), amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.')
    }[k] || fix(2, ',', '.')));
  }

  function toast(msg) {
    const t = document.createElement('div');
    t.className = 'mka-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(() => t.remove(), 3200);
  }

  /* ---------- Dialogs (menu, cart, size guide) ---------- */
  let lastOpener = null;
  function openDialog(id, opener) {
    const d = document.getElementById(id);
    if (!d || typeof d.showModal !== 'function') return false;
    lastOpener = opener || document.activeElement;
    if (!d._mkaWatch) {
      d._mkaWatch = new MutationObserver(() => {
        if (d.open) return;
        $$('[aria-expanded="true"][data-mka-open="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
      });
      d._mkaWatch.observe(d, { attributes: true, attributeFilter: ['open'] });
    }
    if (!d.open) d.showModal();
    if (opener && opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'true');
    return true;
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-mka-open]');
    if (o && openDialog(o.dataset.mkaOpen, o)) { e.preventDefault(); return; }
    const c = e.target.closest('[data-mka-close]');
    if (c) { const d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('mka-dialog')) e.target.close(); // backdrop click
  });

  /* ---------- Predictive search ---------- */
  $$('[data-mka-search]').forEach((form) => {
    const input = $('input[type=search]', form), box = $('.mka-suggest', form);
    if (!input || !box) return;
    let timer, ctrl, active = -1;
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const opts = () => $$('a', box);
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) return close();
      timer = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const url = `${R.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const r = data.resources.results;
          const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
          let html = '';
          if (r.collections && r.collections.length) {
            html += '<p class="mka-suggest__h">Categories</p>' + r.collections.slice(0, 3).map((c) => `<a href="${c.url}" role="option"><span class="mka-suggest__t">${esc(c.title)}</span></a>`).join('');
          }
          if (r.products && r.products.length) {
            html += '<p class="mka-suggest__h">Products</p>' + r.products.map((p) => {
              const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=120" alt="" width="52" height="52" loading="lazy">` : '';
              const price = p.price ? `<span class="mka-suggest__p">${esc(money(Math.round(parseFloat(p.price) * 100)))}${p.available ? '' : ' · Sold out'}</span>` : '';
              return `<a href="${p.url}" role="option">${img}<span><span class="mka-suggest__t">${esc(p.title)}</span><br>${price}</span></a>`;
            }).join('');
            html += `<a class="mka-suggest__all" href="${R.search}?q=${encodeURIComponent(q)}&type=product&options[prefix]=last" role="option">See all results for “${esc(q)}”</a>`;
          }
          if (!html) html = `<p class="mka-suggest__none">No matches for “${esc(q)}”. Try a sport (e.g. “volleyball”), a model (“Lightning”) or “kneepads”.</p>`;
          box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
        } catch (err) { if (err.name !== 'AbortError') close(); }
      }, 180);
    });
    input.addEventListener('keydown', (e) => {
      const list = opts(); if (box.hidden || !list.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
        list.forEach((a, i) => a.setAttribute('aria-selected', i === active ? 'true' : 'false'));
        list[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); list[active].click(); }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  });

  /* ---------- Collection & search filters (Section Rendering API) ---------- */
  const col = $('[data-mka-collection]');
  if (col) {
    const sectionId = col.dataset.section;
    let ctrl, priceTimer;
    const setOpen = (open) => {
      const f = $('[data-mka-filters]', col); if (!f) return;
      f.classList.toggle('is-open', open); document.body.classList.toggle('is-locked', open);
      const btn = $('[data-mka-filter-toggle]', col); btn && btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { const c = $('[data-mka-filter-close]', col); c && c.focus(); }
    };
    async function load(url, push = true, keepOpen = false) {
      ctrl && ctrl.abort(); ctrl = new AbortController();
      const inner = $('[data-mka-col-inner]', col); inner && inner.classList.add('is-loading');
      const focusName = document.activeElement && document.activeElement.name, focusVal = document.activeElement && document.activeElement.value;
      try {
        const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
        const res = await fetch(u, { signal: ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = parse(await res.text());
        const fresh = $('[data-mka-col-inner]', doc);
        if (fresh && inner) inner.replaceWith(fresh);
        if (push) { u.searchParams.delete('section_id'); history.pushState({ mka: 1 }, '', u.pathname + u.search); }
        if (keepOpen) setOpen(true);
        if (focusName) { const el = $$(`[name="${CSS.escape(focusName)}"]`, col).find((x) => x.value === focusVal) || $(`[name="${CSS.escape(focusName)}"]`, col); el && el.focus({ preventScroll: true }); }
        const live = $('[data-mka-live]', col); if (live) live.textContent = ($('[data-mka-count-text]', col) || {}).textContent || '';
      } catch (err) { if (err.name !== 'AbortError') location.href = url; }
    }
    const formUrl = (form) => {
      const p = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') p.append(k, v); });
      return form.getAttribute('action') + (p.toString() ? '?' + p.toString() : '');
    };
    col.addEventListener('change', (e) => {
      const form = e.target.closest('[data-mka-facets]') || (e.target.form && e.target.form.matches('[data-mka-facets]') ? e.target.form : null);
      if (!form) return;
      if (e.target.type === 'number') return; // handled on input with debounce
      load(formUrl(form), true, window.matchMedia('(max-width: 899px)').matches && $('[data-mka-filters]', col).classList.contains('is-open'));
    });
    col.addEventListener('input', (e) => {
      if (e.target.type !== 'number') return;
      const form = e.target.form; clearTimeout(priceTimer);
      priceTimer = setTimeout(() => load(formUrl(form), true, $('[data-mka-filters]', col).classList.contains('is-open')), 700);
    });
    col.addEventListener('submit', (e) => { if (e.target.matches('[data-mka-facets]')) { e.preventDefault(); load(formUrl(e.target)); } });
    col.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-mka-facet-link]');
      if (a) { e.preventDefault(); load(a.href, true, $('[data-mka-filters]', col).classList.contains('is-open')); if (a.closest('.mka-pager')) col.scrollIntoView({ behavior: 'smooth' }); return; }
      if (e.target.closest('[data-mka-filter-toggle]')) { setOpen(true); return; }
      if (e.target.closest('[data-mka-filter-close]')) { setOpen(false); const b = $('[data-mka-filter-toggle]', col); b && b.focus(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && $('[data-mka-filters].is-open', col)) setOpen(false); });
    window.addEventListener('popstate', () => load(location.href, false));
  }

  /* ---------- Product page: variant picker, gallery, add to bag ---------- */
  $$('[data-mka-product]').forEach((root) => {
    const vjson = $('[data-mka-variants]', root) || $('[data-mka-variants]');
    const variants = vjson ? JSON.parse(vjson.textContent) : [];
    const form = $('[data-mka-form]', root);
    const idInput = $('[data-mka-variant-id]', root);
    const addBtn = $('[data-mka-add]', root);
    const stock = $('[data-mka-stock]', root);
    const priceEl = $('[data-mka-price]', root);
    const errEl = $('[data-mka-error]', root);
    const sets = $$('[data-mka-option]', root);
    const track = $('[data-mka-track]', root);
    const thumbs = $$('[data-mka-thumb]', root);
    const counter = $('[data-mka-counter]', root);
    const sticky = $('[data-mka-sticky]');
    const stickyBtn = sticky && $('button', sticky);

    const selected = () => sets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (sel) => variants.find((v) => v.options.every((o, i) => sel[i] === null ? false : o === sel[i]));

    function goToMedia(id, smooth = true) {
      if (!track) return;
      const slide = $(`[data-media-id="${id}"]`, track); if (!slide) return;
      const left = slide.offsetLeft;
      track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      setTimeout(() => { if (Math.abs(track.scrollLeft - left) > 4) { track.scrollLeft = left; syncThumbs(); } }, 500);
    }
    function syncThumbs() {
      if (!track) return;
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      if (counter) counter.textContent = `${i + 1} / ${$$('.mka-gallery__slide', track).length}`;
    }
    if (track) {
      track.addEventListener('scroll', () => { clearTimeout(track._t); track._t = setTimeout(syncThumbs, 60); }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.mkaThumb)));
      $$('[data-mka-slide]', root).forEach((b) => b.addEventListener('click', () => {
        const w = track.clientWidth, i = Math.round(track.scrollLeft / w) + (b.dataset.mkaSlide === 'next' ? 1 : -1);
        const slides = $$('.mka-gallery__slide', track); const n = slides[(i + slides.length) % slides.length]; n && goToMedia(n.dataset.mediaId);
      }));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' }); }
      });
    }

    function update(fromUser) {
      const sel = selected();
      // availability of every value given the other selected options
      sets.forEach((fs, i) => {
        $$('input', fs).forEach((inp) => {
          const test = sel.slice(); test[i] = inp.value;
          const ok = variants.some((v) => v.available && v.options.every((o, j) => j === i ? o === inp.value : (test[j] === null || o === test[j])));
          const lab = inp.nextElementSibling;
          lab.classList.toggle('is-unavailable', !ok);
          lab.title = ok ? '' : 'Sold out';
          const sr = $('.mka-sr', lab); if (sr) sr.textContent = ok ? '' : ' (sold out)';
        });
        const shown = $('[data-mka-selected]', fs); if (shown) shown.textContent = sel[i] || 'choose';
      });
      const missing = sets.findIndex((fs, i) => sel[i] === null);
      const v = missing === -1 ? findVariant(sel) : null;
      errEl && (errEl.textContent = '');
      if (missing !== -1) {
        const name = sets[missing].dataset.name || 'option';
        addBtn.disabled = true; addBtn.textContent = `Choose your ${name.toLowerCase()}`;
        stock.className = 'mka-stock is-choose'; stock.textContent = `Select a ${name.toLowerCase()} to see availability`;
        stickyBtn && (stickyBtn.textContent = `Choose ${name.toLowerCase()}`);
        return;
      }
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        stock.className = 'mka-stock is-out'; stock.textContent = 'This combination is not available';
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = `<div class="mka-price">${v.compare > v.price ? `<span class="is-sale">${money(v.price)}</span><s>${money(v.compare)}</s>` : `<span>${money(v.price)}</span>`}</div>`;
      if (v.available) {
        addBtn.disabled = false; addBtn.textContent = `Add to bag · ${money(v.price)}`;
        if (v.qty !== null && v.qty > 0 && v.qty <= 2) { stock.className = 'mka-stock is-low'; stock.textContent = v.qty === 1 ? 'In stock – last one in this size' : `In stock – ${v.qty} left in this size`; }
        else { stock.className = 'mka-stock is-ok'; stock.textContent = 'In stock – ships from Nicosia'; }
      } else {
        addBtn.disabled = true; addBtn.textContent = 'Sold out';
        stock.className = 'mka-stock is-out'; stock.textContent = 'Sold out in this option – try another size or ask us on WhatsApp';
      }
      if (stickyBtn) { stickyBtn.disabled = addBtn.disabled; stickyBtn.textContent = addBtn.textContent; }
      if (fromUser) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
        if (v.media) goToMedia(v.media);
      }
    }
    sets.forEach((fs) => fs.addEventListener('change', () => update(true)));
    if (sets.length) update(false);

    // quantity steppers
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mka-step]'); if (!b || !root.contains(b)) return;
      const inp = b.parentElement.querySelector('input'); const n = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(b.dataset.mkaStep)); inp.value = n;
    });

    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      const qty = Math.max(1, parseInt(($('[name=quantity]', form) || {}).value, 10) || 1);
      const label = addBtn.textContent; addBtn.disabled = true; addBtn.textContent = 'Adding…';
      try {
        const res = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qty }], sections: 'mka-cart-drawer', sections_url: location.pathname }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        Cart.render(data.sections);
        Cart.open(addBtn);
      } catch (err) { errEl && (errEl.textContent = err.message); }
      finally { addBtn.disabled = false; addBtn.textContent = label; update(false); }
    });

    // sticky add bar on mobile
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      stickyBtn.addEventListener('click', () => {
        if (addBtn.disabled) { const s = sets.find((fs, i) => selected()[i] === null) || sets[0]; s && s.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit();
      });
    }

    // related products
    const rec = $('[data-mka-recs]');
    if (rec && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(async ([en]) => {
        if (!en.isIntersecting) return; io.disconnect();
        try { const doc = parse(await (await fetch(rec.dataset.url)).text()); const n = $('[data-mka-recs]', doc); if (n && n.innerHTML.trim()) rec.innerHTML = n.innerHTML; else rec.remove(); } catch (_) { rec.remove(); }
      }, { rootMargin: '400px' });
      io.observe(rec);
    }
  });

  /* ---------- Cart (drawer + page) ---------- */
  const Cart = {
    sections() { return Array.from(new Set($$('[data-mka-cart-section]').map((n) => n.dataset.mkaCartSection))); },
    render(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        const html = sections[id]; if (!html) return;
        const doc = parse(html);
        $$(`[data-mka-cart-section="${id}"]`).forEach((target) => {
          const fresh = $(`[data-mka-cart-section="${id}"]`, doc);
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      });
      const c = $('[data-mka-cart-count-source]');
      if (c) $$('[data-mka-count]').forEach((n) => { n.textContent = c.dataset.mkaCartCountSource; n.closest('a,button') && n.closest('a,button').setAttribute('aria-label', `Bag, ${c.dataset.mkaCartCountSource} items`); });
    },
    open(opener) { if (!openDialog('MkaCartDrawer', opener)) location.href = R.cart; },
    async change(key, quantity, el) {
      const box = el && el.closest('.mka-cart'); box && box.classList.add('is-busy');
      try {
        const res = await fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: Cart.sections().join(','), sections_url: location.pathname }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not update your bag');
        Cart.render(data.sections);
        if (quantity > 0 && data.items) {
          const line = data.items.find((i) => i.key === key);
          if (line && line.quantity < quantity) toast(`Only ${line.quantity} available – quantity updated`);
        }
      } catch (err) { toast(err.message); }
      finally { $$('.mka-cart.is-busy').forEach((b) => b.classList.remove('is-busy')); }
    }
  };
  window.MkaCart = Cart;
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-mka-cart-open]');
    if (openBtn && document.getElementById('MkaCartDrawer') && !document.querySelector('[data-mka-cart-page]')) { e.preventDefault(); Cart.open(openBtn); return; }
    const step = e.target.closest('[data-mka-line-step]');
    if (step) {
      e.preventDefault();
      const line = step.closest('[data-key]'); const inp = $('input', line);
      const q = Math.max(0, (parseInt(inp.value, 10) || 0) + Number(step.dataset.mkaLineStep));
      Cart.change(line.dataset.key, q, step); return;
    }
    const rm = e.target.closest('[data-mka-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(rm.closest('[data-key]').dataset.key, 0, rm); }
  });
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-mka-line-qty]'); if (!inp) return;
    Cart.change(inp.closest('[data-key]').dataset.key, Math.max(0, parseInt(inp.value, 10) || 0), inp);
  });
})();
